export function accordion() {
  var linkToggle = document.querySelectorAll(".js-toggle");

  if (linkToggle) {
    for (let i = 0; i < linkToggle.length; i++) {
      const heading = linkToggle[i];

      if (heading.closest("#supplier-archive-filters")) {
        continue;
      }

      const container = heading.nextElementSibling;
      const isInAccessibilityWidget = heading.closest("#accessibility-widget");

      const storageKey = `accordion-${i}-state`;
      let shouldBeOpen = false;

      if (isInAccessibilityWidget) {
        const containerState = sessionStorage.getItem(storageKey);

        if (containerState === "open") {
          shouldBeOpen = true;
        } else if (containerState === "closed") {
          shouldBeOpen = false;
        } else {
          // Default to open on first load inside the widget
          shouldBeOpen = true;
          sessionStorage.setItem(storageKey, "open");
        }
      }

      if (shouldBeOpen) {
        container.classList.add("active", "open");
        heading.classList.add("active");
        container.style.height = `${container.scrollHeight}px`;
      } else {
        container.classList.remove("active", "open");
        heading.classList.remove("active");
        container.style.height = "0px";
      }

      heading.addEventListener("click", function (event) {
        event.preventDefault();

        const isOpen = container.classList.contains("active");

        if (!isOpen) {
          // Close all other items in the same accordion group
          if (!isInAccessibilityWidget) {
            const parentAccordion = heading.closest(".accordion");
            if (parentAccordion) {
              parentAccordion.querySelectorAll(".js-toggle").forEach(function (sibling) {
                if (sibling !== heading && !sibling.closest("#supplier-archive-filters")) {
                  const siblingContainer = sibling.nextElementSibling;
                  if (siblingContainer && siblingContainer.classList.contains("active")) {
                    siblingContainer.classList.remove("active", "open");
                    sibling.classList.remove("active");
                    siblingContainer.style.height = "0px";
                  }
                }
              });
            }
          }

          container.classList.add("active", "open");
          heading.classList.add("active");
          container.style.height = `${container.scrollHeight}px`;

          if (isInAccessibilityWidget) {
            sessionStorage.setItem(storageKey, "open");
          }
        } else {
          container.classList.remove("active", "open");
          heading.classList.remove("active");
          container.style.height = "0px";

          if (isInAccessibilityWidget) {
            sessionStorage.setItem(storageKey, "closed");
          }
        }
      });
    }
  }
}
